<script setup lang="ts">
interface Props {
  message?: string;
  variant?: "error" | "warning" | "success" | "";
}

const props = withDefaults(defineProps<Props>(), {
  message: "",
  variant: "error",
});

const variantClasses = computed(() => ({
  "banner-error--error": props.variant === "error",
  "banner-error--warning": props.variant === "warning",
  "banner-error--success": props.variant === "success",
}));
</script>

<template>
  <div
    v-if="message"
    class="banner-error"
    :class="variantClasses"
  >
    <p class="small-text">{{ message }}</p>
  </div>
</template>

<style lang="scss">
.banner-error {
  padding: 0.5rem;
  border-radius: 0.4rem;
  margin-bottom: 0.5rem;
  width: calc(100% - 1rem);
  p {
    margin: 0;
    text-align: left !important;
  }

  &--error {
    border-left: solid 2px var(--color-pink-1);
    background-color: var(--color-pink-3);
    color: var(--color-pink-1);
  }

  &--warning {
    border-left: solid 2px var(--color-yellow-1);
    background-color: var(--color-yellow-2);
  }

  &--success {
    border-left: solid 2px var(--color-green-1);
    background-color: var(--color-green-3);
    color: var(--color-green-1);
  }
}
</style>
